import Http from '../libs/http';

export default {
  // 获取同业信息
  getPeerInfo() {
    return Http.post('/visa_peer_query');
  },
};



// WEBPACK FOOTER //
// ./src/api/peer-api.js